import React from 'react';
const CheckboxGroupContext = React.createContext(null);
export const CheckboxGroupContextProvider = CheckboxGroupContext.Provider;
export default CheckboxGroupContext;
